import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { StepInterviewComponent } from '@edtech-ui/dashboard/student/ai-interview/interview-setup/step-interview/step-interview.component';

@Injectable({
	providedIn: 'root'
})
export class CandeactivateService
	implements CanDeactivate<StepInterviewComponent> {

	constructor(private toast: ToastrService) { }

	canDeactivate(component: any): boolean {

		// Interview page
		if (component instanceof StepInterviewComponent) {
			if (!component.canExitInterview()) {
				this.toast.warning(
					'Back navigation is disabled during the interview',
					'Action Restricted',
					{ timeOut: 2000 }
				);
				return false;
			}
		}

		return true;
	}
}
